@if (formGroup().value.value?.caregiver) {
    <div class="flex justify-between">
        <mds-checkbox
            [attr.data-cy]="'caregiver-checkbox'"
            [label]="label()"
            [formCtrl]="formGroup().controls.checked"
        />

        <div class="flex flex-row gap-medpace">
            @if (showBookButton() && formGroup().controls.checked.value) {
                @if (formGroup().value.value?.bookable) {
                    <mds-button
                        [id]="'getthere-book-btn'"
                        [label]="'Book via GetThere'"
                        [variant]="'outline'"
                        (clickEvent)="bookViaGetThereForCaregiver.emit(formGroup().value.value.caregiver)"
                    />
                } @else {
                    <mds-button
                        [id]="'no-booking-btn'"
                        [label]="'Nothing to book'"
                        [variant]="'outline'"
                        [disabled]="true"
                    />
                }
            }
        </div>
    </div>
}
